import { createReducer } from 'redux-act'
import { translatedConfigSelector as configSelector } from '~/config'
import i18n from '~/i18n'
const __ = i18n.t.bind(i18n);
import { Entity } from '~/utils/entity-utils'
import { all } from 'redux-saga/effects'
import API from '~/api'

const entityName = 'shop';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = entity.actions;

// WORKERS
export const workers = { ...entity.workers };

// SAGA
export function * saga() {
  yield all(entity.saga);
}


/*
 export const PAYMENT_STATUS_PENDING = 'pending';
 export const PAYMENT_STATUS_PAID = 'paid';
 export const PAYMENT_STATUS_FAILED = 'failed';
 export const PAYMENT_STATUS_AUTHORIZED = 'authorized';

 export const getPaymentStatusOptions = () => ([
 { value: PAYMENT_STATUS_PENDING, label: 'Pending', text: 'Pending'  },
 { value: PAYMENT_STATUS_PAID, label: 'Paid', text: 'Paid' },
 { value: PAYMENT_STATUS_FAILED, label: 'Payment Failed', text: 'Payment Failed' },
 { value: PAYMENT_STATUS_AUTHORIZED, label: 'Authorized', text: 'Authorized' },
 ]);

 */

export const ACCOUNTS_DISABLED = 'disabled';
export const ACCOUNTS_REQUIRED = 'required';
export const ACCOUNTS_OPTIONAL = 'optional';

export const getAccountOptions = () => ([
  { value: ACCOUNTS_DISABLED, label: __("Accounts disabled"), text: __("Accounts disabled") },
  { value: ACCOUNTS_REQUIRED, label: __("Accounts required"), text: __("Accounts required") },
  { value: ACCOUNTS_OPTIONAL, label: __("Accounts optional"), text: __("Accounts optional") },
]);

export const NAME_NOT_REQUIRED = 'not_required';
export const NAME_LAST_NAME_ONLY = 'last_name_only';
export const NAME_FULL_NAME = 'full_name';

export const getNameOptions = () => ([
  { value: NAME_NOT_REQUIRED, label: __("Name not required"), text: __("Name not required") },
  { value: NAME_LAST_NAME_ONLY, label: __("Only last name required"), text: __("Only last name required") },
  { value: NAME_FULL_NAME, label: __("Full name required"), text: __("Full name required") },
]);

export const BILLING_ADDRESS_DISABLED = 'disabled';
export const BILLING_ADDRESS_COMPANY_ONLY = 'company_only';
export const BILLING_ADDRESS_ENABLED = 'enabled';

export const getBillingAddressOptions = () => ([
  { value: BILLING_ADDRESS_DISABLED, label: __("Billing Address Disabled"), text: __("Billing Address Disabled") },
  { value: BILLING_ADDRESS_COMPANY_ONLY, label: __("Billing Address for Companies Only"), text: __("Billing Address for Companies Only") },
  { value: BILLING_ADDRESS_ENABLED, label: __("Billing Address Enabled"), text: __("Billing Address Enabled") },
]);

export const ADDRESS_LINE_2_HIDDEN = 'hidden';
export const ADDRESS_LINE_2_OPTIONAL = 'optional';
export const ADDRESS_LINE_2_REQUIRED = 'required';

export const getAddressLineOptions = () => ([
  { value: ADDRESS_LINE_2_HIDDEN, label: __("Address Line 2 hidden"), text: __("Address Line 2 hidden") },
  { value: ADDRESS_LINE_2_OPTIONAL, label: __("Address Line 2 optional"), text: __("Address Line 2 optional") },
  { value: ADDRESS_LINE_2_REQUIRED, label: __("Address Line 2 required"), text: __("Address Line 2 required") },
]);

export const PHONE_HIDDEN = 'hidden';
export const PHONE_OPTIONAL = 'optional';
export const PHONE_REQUIRED = 'required';

export const getPhoneOptions = () => ([
  { value: PHONE_HIDDEN, label: __("Phone Number hidden"), text: __("Phone Number hidden") },
  { value: PHONE_OPTIONAL, label: __("Phone Number optional"), text: __("Phone Number optional") },
  { value: PHONE_REQUIRED, label: __("Phone Number required"), text: __("Phone Number required") },
]);

export const reducer = createReducer(entity.reducer, {});

export default {
  actions,
  workers,
  saga,
  reducer
}
